import React, { useState, useEffect } from "react";
import { MessageSquare } from "lucide-react";
import { Card } from "@shared/ui/card";
import { useParams } from "react-router-dom";
import { useWorkflowsData } from "../hooks";

interface Workflow {
  id: string;
  name: string;
  status: string;
  schedule: string;
  date: string;
}

interface WorkflowCardProps {
  source: number;
  sourceId: number;
  sourceName: string;
}

const WorkflowCard: React.FC<WorkflowCardProps> = ({
  source,
  sourceId,
  sourceName,
}) => {
  
  const { data: workflowData } = useWorkflowsData(sourceId, sourceName);
  console.log(workflowData)

  if (workflowData?.result?.length === 0) {
    return (
      <Card className="p-6">
        <h2 className="text-sm font-bold text-gray-900 mb-4">
          Workflows Using This {sourceName}
        </h2>
        <div className="text-gray-500 text-sm py-4">
          No workflows found for this {sourceName}.
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6">
      <h2 className="text-sm font-bold text-gray-900 mb-4">
        Workflows Using This {sourceName}
      </h2>

      {/* Scrollable container */}
      <div className="max-h-[500px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400 scroll-smooth">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {workflowData?.result?.map((workflow) => (
            <div
              key={workflow.id}
              className="border border-gray-200 rounded-lg p-4 hover:border-gray-300 hover:shadow-sm transition-all cursor-pointer bg-white"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
                    <MessageSquare className="w-5 h-5 text-purple-600" />
                  </div>
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-gray-900 mb-1 line-clamp-2">
                    {workflow?.workflowName}
                  </h3>

                  <div className="flex items-center gap-2 text-xs text-gray-600 mb-2">
                    <span className="flex items-center gap-1">
                      <span className="font-medium">Status:</span>
                      <span
                        className={
                          workflow.status === "Active"
                            ? "text-green-600"
                            : "text-gray-600"
                        }
                      >
                        {workflow.workflowStatus}
                      </span>
                    </span>
                    <span className="text-gray-400">•</span>
                    <span className="flex items-center gap-1">
                      <span className="font-medium">Action Type:</span>
                      <span>{workflow.actionType}</span>
                    </span>
                  </div>

                  <div className="text-xs text-gray-500 mt-2">
                    {workflow.createdDate}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default WorkflowCard;